export const makePharmacyTitle = (pharmacy, full = false) => {
  if (!pharmacy) {
    return '—';
  }

  const { zip, address, pharmacyName, phone } = pharmacy;

  return !full
    ? `${zip}, ${address}, ${pharmacyName}`
    : `${pharmacyName}, ${address}, ${zip}, \n${phone}`;
};



// WEBPACK FOOTER //
// ./src/utils/makePharmacyTitle.js